// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i97EU","col":"styles_col__2McXD","actions":"styles_actions__1igx8","conflict":"styles_conflict__1e3w-"};